<template>
  <div>
    <div class="ls_drawer_main_content">
      <h1 class="item_detail_header mb-15">
        {{ detail.name }}
        <Tag v-if="detail.applied" color="success">проведен</Tag>
        <Tag v-else color="warning">не проведен</Tag>
        <Tag v-show="detail.deleted_date" color="error">Удален</Tag>
      </h1>


      <div class="fs-15 color-grey mb-30">
        <!-- ORDER DATE -->
        <Row>
          <Col span="12">
            Дата документа:
          </Col>
          <Col span="12">
            {{ formatDateTime(detail.order_date) }}
          </Col>
        </Row>

        <!-- CATEGORY-->
        <Row v-if="detail.category_display">
          <Col span="12">
            Категория платежа:
          </Col>
          <Col span="12">
            {{ detail.category_display }}
          </Col>
        </Row>

        <!-- ACCOUNT-->
        <Row>
          <Col span="12">
            Счет:
          </Col>
          <Col span="12">
            <router-link
              v-if="display_account_link"
              :to="{ name: 'account_detail', params: { id: detail.account } }"
            >{{ detail.account_ext.name }}</router-link
            >
            <span v-else>{{ detail.account_ext.name }}</span>
          </Col>
        </Row>

        <!-- COUNTERPART-->
        <Row v-if="detail.counterpart.type">
          <Col span="12">
            <!--Контрагент:-->
            {{ getCounterpartTypeLabel(detail.counterpart.type) }}
            <span v-show="detail.counterpart.type === 'account' && detail.type === 'outgoing'">(получатель):</span>
            <span v-show="detail.counterpart.type === 'account' && detail.type === 'coming'">(отправитель):</span>
          </Col>
          <Col span="12">
            <!--          <span v-if="detail.counterpart.type === 'account'">-->
            <!--            <router-link-->
            <!--              v-if="display_account_link"-->
            <!--              :to="{ name: 'account_detail', params: { id: detail.counterpart.id } }"-->
            <!--              >{{ detail.counterpart_display }}</router-link>-->
            <!--          </span>-->
            <span v-if="detail.counterpart.type === 'account'">
            <router-link
              v-if="display_account_link"
              :to="{ name: 'account_detail', params: { id: detail.counterpart.id } }"
            >{{ detail.counterpart_display }}</router-link>
          </span>
            <span v-else>
              {{ detail.counterpart_display }}
          </span>
          </Col>
        </Row>

        <!-- SUM -->
        <Row>
          <Col span="12">
            Сумма:
          </Col>
          <Col span="12">
            {{ formatNumber(detail.sum) }} {{ currency }}
          </Col>
        </Row>

        <!-- PRODUCT_ORDER-->
        <Row v-if="detail.product_order">
          <Col span="12">
            Товарный документ:
          </Col>
          <Col span="12">
            <router-link
              v-if="display_product_order_link"
              :to="{ name: 'product_order_detail', params: { id: detail.product_order } }"
            >{{ detail.product_order_name }}</router-link
            >
            <span v-else>{{ detail.product_order_name }}</span>
          </Col>
        </Row>

        <!-- DESCRIPTION -->
        <Row>
          <Col span="12">
            Комментарий:
          </Col>
          <Col span="12">
            {{ detail.description }}
          </Col>
        </Row>
      </div>



    </div>
    <div class="ls_drawer_footer">
      <Button style="margin-right: 8px" type="error" @click="cancelAction()"> <Icon type="md-close" /></Button>
      <Button v-if="display_edit_button" type="info" @click="editAction()"><Icon type="md-create" /></Button>
      <!--<Button type="error" @click="deleteAction()" style="float: left"-->
        <!--&gt;Удалить-->
      <!--</Button>-->
    </div>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { BaseDetailData } from "../../base/base_detail.js";
import { getCounterpartTypeLabel } from './func.js'

let _app = BaseDetailData();

_app.methods.editAction = function() {
  this.$router.push({
    name: this.item_type + "_edit",
    params: { id: this.id }
  });
};

_app.methods.getCounterpartTypeLabel = function(type) {
  return getCounterpartTypeLabel(type)
};

export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/money_order/moneyOrderDetail.vue